<template>
    <kiosk-team-details :teamId="props.teamId">
        <div
            class="vx-col-span-12 lg:vx-col-span-10 vx-flex vx-flex-col vx-w-full vx-max-w-screen-sm vx-justify-center"
        >
            <page-header> Emergency Tools </page-header>
            <div class="vx-max-w-screen-sm vx-w-full vx-flex vx-flex-col vx-gap-8">
                <vx-expandable-card>
                    <template v-slot:content>
                        <div class="vx-flex vx-flex-col vx-gap-4">
                            <kiosk-team-feature
                                v-for="(feature, index) in features"
                                :key="features[index].id"
                                v-model="features[index]"
                                :teamId="props.teamId"
                            >
                            </kiosk-team-feature>
                        </div>
                    </template>
                </vx-expandable-card>
            </div>
        </div>
    </kiosk-team-details>
</template>

<script setup>
import KioskTeamDetails from './KioskTeamDetails.vue';
import { VxExpandableCard } from '@voxie/frontend-components';
import PageHeader from '../../general/PageHeader.vue';
import { ref } from 'vue';
import KioskTeamFeature from './KioskTeamFeature.vue';
import adminFeaturesClient from '~/services/adminFeaturesClient';
import { HTTP_INTERNAL_SERVER_ERROR, HTTP_NOT_FOUND } from '~/support/HttpStatuses';
import { useToasted } from '~/composables/useToasted';

const props = defineProps({
    teamId: {
        type: Number,
        required: true,
    },
});

const toasted = useToasted();

const featureIds = ['automations_disabled', 'campaigns_disabled'];
const features = ref([]);

const getFeatures = async () => {
    try {
        const response = await adminFeaturesClient.getFeatures(props.teamId);
        features.value = response.data.data.filter((feature) => featureIds.includes(feature.id));
    } catch (e) {
        if (
            !e?.response?.status ||
            e?.response?.status >= HTTP_INTERNAL_SERVER_ERROR ||
            e?.response?.status === HTTP_NOT_FOUND
        ) {
            toasted?.global.platform_error();
        } else {
            toasted?.error(e?.response?.data?.message || 'Something went wrong.');
        }
    }
};

getFeatures();
</script>
